import { createFeatureSelector, createSelector } from '@ngrx/store'
import { OnboardingState } from '../state/onboarding.state'
import { ScreenConfigApiModel } from 'src/app/models/api.model'

const getOnboardingState = createFeatureSelector<OnboardingState>('onboarding')

export const getCompany = createSelector(getOnboardingState, s => s.company)
export const getEntities = createSelector(getOnboardingState, s => s.entities)
export const getSopSettings = createSelector(getOnboardingState, s => s.sopSettings)

export const selectAllScreenConfigs = createSelector(getOnboardingState, s => s.screenConfigs)

export const selectEmployeeConfig = createSelector(
  selectAllScreenConfigs,
  (configs: ScreenConfigApiModel[]) => configs.find(c => c.type === 'EMPLOYEE_NEW_JOINEE_WORKFLOW_CONFIG') ?? null
)

export const selectAdminConfig = createSelector(
  selectAllScreenConfigs,
  (configs: ScreenConfigApiModel[]) => configs.find(c => c.type === 'ADMIN_NEW_JOINEE_WORKFLOW_CONFIG') ?? null
)

export const selectForm11Config = createSelector(
  selectAllScreenConfigs,
  (configs: ScreenConfigApiModel[]) => configs.find(c => c.type === 'FORM_11_PDF_CONFIG') ?? null
)

